import script from "./CvStructuredListItemSelectable.vue?vue&type=script&setup=true&lang=js"
export * from "./CvStructuredListItemSelectable.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__